/**
 * Bettr lazy media — adds .is-loaded to img.custom-lazy after the image
 * finishes downloading. Pairs with assets/custom-lazy-media.css which holds
 * the blur-to-sharp + opacity transition.
 *
 * Behavior:
 *   - On DOM ready: sweep every img.custom-lazy. If already complete (cached),
 *     reveal immediately. Otherwise listen for `load` once.
 *   - On `error`: reveal anyway so a broken image doesn't stay blurred.
 *   - On `shopify:section:load`: re-sweep so newly-injected images reveal.
 *
 * The script is `defer` in layout/theme.liquid so it runs after HTML parse
 * but before DOMContentLoaded. Module-private; no globals.
 */
(function () {
  'use strict';

  function reveal(img) {
    if (!img || img.classList.contains('is-loaded')) return;
    img.classList.add('is-loaded');
  }

  function sweep() {
    var imgs = document.querySelectorAll('img.custom-lazy:not(.is-loaded)');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      /* Cached images report complete=true with naturalHeight > 0. */
      if (img.complete && img.naturalHeight !== 0) {
        reveal(img);
      } else {
        img.addEventListener('load', function (e) { reveal(e.target); }, { once: true });
        img.addEventListener('error', function (e) { reveal(e.target); }, { once: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }

  /* Re-sweep when Shopify Theme Editor reloads a section (newly-injected imgs). */
  document.addEventListener('shopify:section:load', sweep);
})();
